<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Redigera email mall
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-text-field
              :rules="[validationRules.required]"
              v-model="model.name"
              label="Mallnamn"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <tiptap-vuetify v-model="model.template" :extensions="extensions" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validationRules } from '@/common/validationRules'
import UPDATE_MAIL_TEMPLATE from '@/gql/mailTemplates/mutations/UpdateMailTemplate.gql'
import { get } from 'vuex-pathify'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
} from 'tiptap-vuetify'

export default {
  name: 'MasterdataEmailTemplatesEdit',

  components: { TiptapVuetify },

  props: {
    uuid: String,
  },

  data() {
    return {
      extensions: [
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3, 4, 5, 6],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      validationRules,
      validForm: true,
      model: {
        name: '',
        template: ``,
      },
    }
  },

  created() {
    for (let prop in this.model) {
      this.model[prop] = this.mailTemplates[this.uuid][prop]
    }
  },

  computed: {
    mailTemplates: get('mailTemplates/data'),
  },

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.updateMailTemplate()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    updateMailTemplate() {
      return this.$apollo.mutate({
        mutation: UPDATE_MAIL_TEMPLATE,
        variables: {
          payload: this.model,
          uuid: this.uuid,
        },
        update: (store, { data }) => {
          this.$store.set('mailTemplates/data', {
            ...this.$store.get('mailTemplates/data'),
            [data.updateMailTemplate.uuid]: data.updateMailTemplate,
          })
        },
      })
    },
  },
}
</script>
